<div class="modal-window-container fx-cover fx-center-all" #container (click)="closeWindow()">
    <div class="modal-window-inner" #window>
        <iframe #teamPortalFrame [src]="teamPortalUrl | safe" class="team-portal-window-iframe" allow="clipboard-write"></iframe>
    </div>
</div>
